/* Jquery */
var $ = require("jquery");

import datepicker from "js-datepicker";

function datePicker() {
    const picker = datepicker('.datepicker', {
        formatter: (input, date, instance) => {
            //const value = date.toLocaleDateString()
            const value = moment(date).format("DD/MM/YYYY")
            input.value = value // => '1/1/2099'

        },
        disabler: function (date) {
            const day = date.getDay(); // Obtener el día de la semana (0 = Domingo, 6 = Sábado)
            return day === 0 || day === 6; // Retornar true para deshabilitar sábados y domingos
        },
        // enableOnReadonly: true,
        dateFormat: "dd-mm-yyyy",
        minDate: new Date(),
        startDay: 1,
        customDays: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
        customMonths: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
    })
}

export default datePicker;

//////////////////////////////////////////////////

